import { showCustomToast } from 'common/components/CustomToast/utils';
import React from 'react';
import { AccessGroupRow } from '..';
import { useMutation } from '@apollo/client';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityAction, EntityType } from 'common/types/utility';
import ACCESS_GROUP_DELETE from './AccessGroupDelete.graphql';
import { AccessGroupDelete, AccessGroupDeleteVariables } from './__generated__/AccessGroupDelete';

interface DeleteUserAccessPoolProps {
  selectedRows: AccessGroupRow[];
}

export const DeleteUserAccessPool: React.FC<DeleteUserAccessPoolProps> = ({
  selectedRows,
}) => {
  const [userAccessGroupDelete] = useMutation<
    AccessGroupDelete,
    AccessGroupDeleteVariables
  >(ACCESS_GROUP_DELETE, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const deletableRows: AccessGroupRow[] = selectedRows.filter(
      (item) => item._isDeletable
    );
    const entityDelete: EntityDeleteInput[] = deletableRows.map((item) => {
      return { id: item.id, rowTimestamp: item._rowTimestamp! };
    });
    const { errors } = await userAccessGroupDelete({
      variables: {
        input: {
          entityDelete,
        },
      },
      update(cache) {
        deletableRows.forEach((item) => {
          const identity = cache.identify({
            ...item,
          });
          cache.evict({ id: identity });
          cache.gc();
        });
      },
    });
    if (errors?.length)
      showCustomToast({
        content: errors[0].message,
        appearance: 'error',
      });
    else {
      showCustomToast({
        content: 'Record deleted successfully.',
        appearance: 'success',
      });
    }
  };

  return (
    <ActionMessageModal
      entityType={EntityType.UserAccessGroup}
      action={EntityAction.Remove}
      disabled={!selectedRows.some((selected) => selected._isDeletable)}
      visible={!!selectedRows.length}
      multiple={{
        validCount: selectedRows.filter((selected) => selected._isDeletable)
          .length,
        invalidNames: selectedRows
          .filter((selected) => !selected._isDeletable)
          .map((selected) => selected.name || ''),
      }}
      onConfirm={_onConfirm}
    />
  );
};
